"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StackPanel = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const tokens_1 = require("../../../styles/tokens");
/** Converts directions to flex properties */
const AlignmentMap = {
    top: "flex-start",
    bottom: "flex-end",
    left: "flex-start",
    right: "flex-end",
    center: "center",
    stretch: "stretch",
    baseline: "baseline",
    "space-between": "space-between",
    "space-around": "space-around",
};
/**
 * @deprecated please use \<Flex\> instead
 */
exports.StackPanel = styled_components_1.default.div `
    display: flex;

    ${(props) => {
    if (props.orientation === "horizontal") {
        return `
                flex-direction: row;
                justify-content: ${props.horizontalContentAlignment
            ? AlignmentMap[props.horizontalContentAlignment]
            : "flex-start"};
                align-items: ${props.verticalContentAlignment
            ? AlignmentMap[props.verticalContentAlignment]
            : "stretch"};
            `;
    }
    else {
        return `
                flex-direction: column;
                justify-content: ${props.verticalContentAlignment
            ? AlignmentMap[props.verticalContentAlignment]
            : "flex-start"};
                align-items: ${props.horizontalContentAlignment
            ? AlignmentMap[props.horizontalContentAlignment]
            : "stretch"};
            `;
    }
}}

    ${(props) => {
    if (props.gutter && Number(props.gutter) > 0) {
        const marginSide = props.orientation === "horizontal"
            ? "margin-left"
            : "margin-top";
        return `
                > * + * {
                    ${marginSide}: ${tokens_1.SIZES[props.gutter]};
                }
            `;
    }
}}
`;
//# sourceMappingURL=StackPanel.js.map